"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _AsyncWorkspacesContainer = _interopRequireDefault(require("./containers/AsyncWorkspacesContainer"));

var _AsyncManageWorkspacesContainer = _interopRequireDefault(require("./containers/AsyncManageWorkspacesContainer"));

var _tracking = require("settings-ui-app/utils/tracking");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: "workspaces",
  component: _AsyncWorkspacesContainer.default
}, _react.default.createElement(_reactRouter.IndexRoute, {
  component: _AsyncManageWorkspacesContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)()
}));

exports.default = _default;
module.exports = exports.default;